// extracted by mini-css-extract-plugin
export default {"vacancy_item":"VacancyItem_vacancy_item__E42Yh","vacancy_info_wrapper":"VacancyItem_vacancy_info_wrapper__HZ53J"};